import React from "react";
import "../Front/index.scss";

const Front = () => {
  return (
    <section id="front">
      <div className="container">
        <div className="front">
          <div className="front--block">
            <h3>Что, как и почему</h3>
            <h1>О КУРСЕ</h1>
            <p>
              Это всё, что ты видишь и кликаешь на сайте или в приложении -{" "}
              <br />
              картинки, кнопочки, анимации и даже бесячая реклама.
            </p>
            <p>
              Самые главные инструменты frontend разработки сайтов это <br />
              JavaScript, HTML и CSS.
            </p>
            <p>
              В Кыргызстане фронтенд-разработчики востребованы практически в{" "}
              <br />
              каждой IT-компании. Это также одно из самых популярных <br />
              направлений для фриланса и удаленной работы. Все потому, что в{" "}
              <br />
              современном мире сайт нужен каждому
            </p>
          </div>
          <div className="front--end">
            <h3>Доступ:</h3>
            <h2>Навсегда</h2>
            <h4>В курс входит: </h4>
            <h2>
              3 модулей <br />
              60материалов
            </h2>
          </div>
        </div>
        <div className="study">
          <div>
            <h2>Для кого это </h2>
            <div className="study--dev">
              <div></div>
              <h3>Для людей с математическим складом ума.</h3>
            </div>
            <h2>Вы изучтие</h2>
            <div className="study--dev">
              <div></div>
              <p>HTML</p>
            </div>
            <div className="study--dev">
              <div></div>
              <p>CSS</p>
            </div>
            <div className="study--dev">
              <div></div>
              <p>JavaScript</p>
            </div>
            <div className="study--dev">
              <div></div>
              <p>Soft skills. Нетехнические навыки</p>
            </div>
          </div>
          <div className="study--developer">
            <div className="study--dev">
              <div></div>
              <p>Кроссплатформенность и кроссбраузерность</p>
            </div>
            <div className="study--dev">
              <div></div>
              <p>Управление версиями</p>
            </div>
            <div className="study--dev">
              <div></div>
              <p>Управление версиями</p>
            </div>
          </div>
        </div>
        <div className="kurs">
          <h2>К каким результатам вас может привести этот курс?</h2>
          <p>
            С каждым днем, с каждым месяцем, с каждым годом вы будете физически
            ощущать, как ваши <br />
            мечты и цели воплощаются в реальность. И каждый день, каждый год вы
            будете видеть, что вы <br />
            живете той жизнью, которую сами для себя выбрали, и именно по тому
            сценарию, который вы <br />
            сами для себя создали.
          </p>
          <p>
            Ваш новый навык планирования изменит вашу жизнь и поможет отточить
            умение выстраивать <br />
            дела в правильной последовательности. Сначала вы будете видеть на
            неделю вперед, потом - на <br />
            месяц, потом - на год, а потом вы будете видеть весь свой путь.
            Система планирования Кайдзен <br />
            позволит вам правильно планировать правильные вещи и увеличить
            степень контроля над <br />
            своей жизнью, чтобы сделать её счастливой и успешной.
          </p>
          <h3>
            Учитесь, применяйте полученные на курсе знания и будьте счастливы!
          </h3>

          <button className="kurs--btn1">Купить курс</button>
          <button className="kurs--btn2">Смотреть программу</button>
        </div>
      </div>
    </section>
  );
};

export default Front;
